import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';
import { TemplateMasterService } from 'src/app/master_modules/masters/apps/template/template-master.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductServiceService } from 'src/app/services/product-service.service';
import { S } from '@angular/cdk/keycodes';
@Component({
  selector: 'app-search-product',
  templateUrl: './search-product.component.html',
  styleUrls: ['./search-product.component.scss']
})
export class SearchProductComponent implements OnInit {
  ecomMyControl = new FormControl();
  bType: any;
  ecomFilteredOptions: Observable<string[]> | any;
  ecomIndustry: any = [];
  subCategoryId: any = "";
  productData: any;
  getVal(ev) {
    if (ev.length === 0) {
      this.bType = '';
    }
  }
  ngOnInit(): void {
    console.log(this.data);
     if (this.data?.selectedProductIds) {
    this.addedProductIds = [...this.data.selectedProductIds]; // set selected product IDs
  }
    if (this.ecomIndustry.length > 0) {
      this.selectBusinessType(this.ecomIndustry[0]);
    }
    this.getEcommerceIndustry();
  }
  selectedProduct : any [] = [];
  selectBusinessType(ev: any) {
   
    this.bType = ev;
    this.subCategoryId = ev.subIndustryId;
    this.getProductList()
  }
  constructor(private dialogRef: MatDialogRef<SearchProductComponent>,
    private _templateService: TemplateMasterService,
    private snackbar: MatSnackBar,
    private productserivice: ProductServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }
  closeDialog() {
    this.dialogRef.close();
  }
  getProductList() {
    var payload = {
      subId: this.subCategoryId,
      pageNo:0,
      pageSize:10000
  
    }
    this.productserivice.getProductList(payload).subscribe(
      {
        next: (res: any) => {
          this.productData = res.data?.data;
          
        }
      }
    )
  }
getEcommerceIndustry() {
  this._templateService.getAllEcommerceIndustries().subscribe(
    (res: any) => {
      this.ecomIndustry = res.data.map((data: any) => ({
        name: data.name,
        industryId: data.parent.id,
        subIndustryId: data.id,
        industryName: data.parent.name,
        subIndustryName: data.name,
      }));

      this.ecomFilteredOptions = this.ecomMyControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._ecomFilter(value || ''))
      ); 
        this.ecomFilteredOptions = this.ecomMyControl.valueChanges.pipe(
  map((value) => this._ecomFilter(value || ''))
);
    },
    (err) => {
      this.snackbar.open(`${err.error.message}`, 'Close');
    }
  );
}


  private _ecomFilter(value: any) {
    const filterValue = value.toLowerCase();

    return this.ecomIndustry.filter((option: any) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  addedproductList: any[]= [];
  addedProductIds: String[] = [];
  updatedProductIds = new Set();
  // addProduct(checkBox, product: any)
  // {  
  //   if(checkBox.checked) {
  //     this.addedProductIds.push(product.itemId);
  //   }
  //   else {
  //     this.addedProductIds = this.addedProductIds.filter((ref) => ref !== product.itemId);
  //   }
    
  // }
  addProduct(checkBox, product: any) {
 if (checkBox.checked) {
    if (!this.addedProductIds.includes(product.itemId)) {
      this.addedProductIds.push(product.itemId);
    }
  } else {
    this.addedProductIds = this.addedProductIds.filter((ref) => ref !== product.itemId);
  }
} 
  doneProduct() {
      this.dialogRef.close({productIds: this.addedProductIds});
  }
}
